import { Badge, Card, ColorSwatch, Group, SimpleGrid, Text } from '@mantine/core';
import { demoDepartments } from '../demo.ts';
import { DemoBadge, Loading, Page, useMe } from '../ui.tsx';

/* The Figma Departments screen: a department is picked at sign-up, shown with a colour and used to
 * filter spaces. The module is proposed (@budovan/domain/proposed Department), so this lists typed
 * demo rows until it has a table and an API. */
export function DepartmentsPage() {
  const me = useMe();
  if (!me.data) return <Loading />;
  const departments = demoDepartments(me.data.organizationId);
  return (
    <Page
      title="Departments"
      description="Picked at sign-up, shown next to people's names, used to filter spaces when booking."
      actions={<DemoBadge what="Departments" />}
    >
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
        {departments.map((department) => (
          <Card key={department.id} withBorder padding="lg">
            <Group justify="space-between">
              <Group gap="sm">
                <ColorSwatch color={department.color ?? '#737373'} size={14} />
                <Text fw={700}>{department.name}</Text>
              </Group>
              <Badge variant="default">Default group</Badge>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </Page>
  );
}
